import React, { useState } from 'react';
import axios from 'axios';
import ResultsCard from './ResultsCard';

export default function LoanNumberLookupForm() {
    const [ssn, setSSN] = useState('');
    const [zipcode, setZipcode] = useState('');
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [loans, setLoans] = useState('');
    const [loanNumber, setLoanNumber] = useState('');


    const handleSubmit = async (e) => {
        e.preventDefault();
        const apiUrl = window.api.apiUrl + "/loan/" + loanNumber + "/servicers";
        const newErrors = {};
        if (loanNumber.length < 6) newErrors.loanNumber = 'Loan Number must be at least 6 digits';

        setErrors(newErrors);

        if (Object.keys(newErrors).length === 0) {
            setLoading(true);
            setSubmitted(false);

            try {
                const response = await axios.get(apiUrl, {
                    params: { loanNumber },
                });

                const data = response.data;

                setLoans(data || []);
                setSubmitted(true);
            } catch (error) {
                console.error(error);
                setErrors({ general: 'Unable to look up loan. Please try again.' });
            } finally {
                setLoading(false);
            }
        }
    };

    const handleLookup = async (e) => {
        e.preventDefault();
        const apiUrl = window.api.apiUrl + "/loan/servicers";
        const newErrors = {};
        if (ssn.length !== 5) newErrors.ssn = 'SSN must be 5 digits';
        if (zipcode.length !== 5) newErrors.zipcode = 'ZIP code must be 5 digits';

        setErrors(newErrors);

        if (Object.keys(newErrors).length === 0) {
            setLoading(true);
            setSubmitted(false);

            try {
                const response = await axios.get(apiUrl, {
                    params: { ssn, zipcode },
                });

                const data = response.data;

                setLoans(data || []);
                setSubmitted(true);
            } catch (error) {
                console.error(error);
                setErrors({ general: 'Unable to look up loan. Please try again.' });
            } finally {
                setLoading(false);
            }
        }
    };

    return (
        <>
            <div className="forms">
                <div className="form-container">
                    <h2>Enter Your <span className="text-gold">Loan Number</span></h2>
                    <p>Type your loan number below</p>

                    <form onSubmit={handleSubmit}>
                        <div className="input-group">
                            <input
                                type="text"
                                inputMode="numeric"
                                maxLength="10"
                                placeholder="Loan Number"
                                value={loanNumber}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d{0,10}$/.test(value)) {
                                        setLoanNumber(value);
                                    }
                                }}
                                className="form-input"
                            />
                            {errors.loanNumber && <span className="error-message">{errors.loanNumber}</span>}
                        </div>
                        <button type="submit" className="form-button btn btn--primary" disabled={loading}>
                            Submit
                        </button>
                    </form>
                </div>

                <div className="form-container">
                    <h2>Find Your <span className="text-gold">Loan Number</span></h2>
                    <p>Easily retrieve your loan number with a few details</p>

                    <form onSubmit={handleLookup}>
                        <div className="input-group">
                            <input
                                type="text"
                                inputMode="numeric"
                                //pattern="\d{5}"
                                maxLength="5"
                                placeholder="Last 5 of SSN"
                                value={ssn}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d{0,5}$/.test(value)) {
                                        setSSN(value);
                                    }
                                }}
                                className="form-input"
                            />
                            {errors.ssn && <span className="error-message">{errors.ssn}</span>}
                        </div>
                        <div className="input-group">
                            <input
                                type="text"
                                inputMode="numeric"
                                //pattern="\d{5}"
                                maxLength="5"
                                placeholder="5-Digit Zip Code"
                                value={zipcode}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d{0,5}$/.test(value)) {
                                        setZipcode(value);
                                    }
                                }}
                                className="form-input"
                            />
                            {errors.zipcode && <span className="error-message">{errors.zipcode}</span>}
                        </div>
                        <button type="submit" className="form-button btn btn--primary" disabled={loading}>
                            Look Up
                        </button>
                    </form>
                </div>
            </div>

            <div className="results-container">
                {loading && (
                    <div className="loading-state">
                        <div className="spinner" />
                        <p>Looking up your loan number...</p>
                    </div>
                )}

                {submitted && loans.length > 0 && !loading && (
                    <div className="results-list">
                        {loans.map((loan, index) => (
                            <ResultsCard key={index} loan={loan} />
                        ))}
                    </div>
                )}

                {submitted && loans.length < 1 && !loading && ( 
                    <div className="card card--secondary card--notFound">
                        <h2>We cannot find your loan based on the information provided.</h2>
                        <h3>
                            Please call us at
                            <strong>
                                <a href="tel:8006729470"> (800) 672-9470 </a>
                            </strong>
                            for help locating your number.
                        </h3>
                    </div>
                )}

                {submitted && errors.general && <p className="error-message">{errors.general}</p>  }
            </div>
        </>
    );
}
